"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class MenuIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M5 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm7 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm7 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" })))));
    }
}
exports.MenuIcon = MenuIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/menu.tsx
// module id = 2152
// module chunks = 0 1 2